import React from 'react'
import PropTypes from 'prop-types'
import { useAnalytics } from '../AnalyticsProvider/AnalyticsProvider'
import { Icon } from '@toasttab/buffet-icons'

import './GuestFeedback.css'

export const GUEST_FEEDBACK_EVENT = 'Guest Feedback Checkout'
export const GUEST_FEEDBACK_GOOD = 'Good'
export const GUEST_FEEDBACK_BAD = 'Bad'

export const GuestFeedback = ({ orderGuid }) => {
  const orderKey = `toast-${orderGuid}`
  const { track } = useAnalytics()
  const [isSubmitted, setSubmittedState] = React.useState(sessionStorage.getItem(orderKey))

  const setIsSubmitted = React.useCallback(isSubmitted => {
    if (isSubmitted) sessionStorage.setItem(orderKey, true)
    setSubmittedState(isSubmitted)
  }, [orderKey])

  const upvote = () => {
    setIsSubmitted(true)
    track(GUEST_FEEDBACK_EVENT, {
      voteInt: 1,
      vote: GUEST_FEEDBACK_GOOD
    })
  }

  const downvote = () => {
    setIsSubmitted(true)
    track(GUEST_FEEDBACK_EVENT, {
      voteInt: -1,
      vote: GUEST_FEEDBACK_BAD
    })
  }

  if (!track) return null

  if (isSubmitted) {
    return (
      <div styleName='guestFeedback' data-testid='guest-feedback-response'>
        <h4>Thank you for your feedback!</h4>
        <p>We're always looking to improve the experience and your opinion is very important to us.</p>
      </div>
    )
  }

  return (
    <div styleName='guestFeedback' data-testid='guest-feedback'>
      <h4>How was your ordering experience?</h4>
      <div styleName='guestFeedbackButtons'>
        <button
          styleName='guestFeedbackButton'
          onClick={downvote}
          title={GUEST_FEEDBACK_BAD}
          data-testid='guest-feedback-downvote'
        >
          <Icon name='thumb_down' />
        </button>
        <button
          styleName='guestFeedbackButton'
          onClick={upvote}
          title={GUEST_FEEDBACK_GOOD}
          data-testid='guest-feedback-upvote'
        >
          <Icon name='thumb_up' />
        </button>
      </div>
    </div>
  )
}

GuestFeedback.propTypes = {
  orderGuid: PropTypes.string.isRequired
}
